import axios from "../../helpers/httpClient";

export default {
    loadGestion: async ({ state, dispatch, commit }, route) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const result = await axios.get(`/information/private/consultaProfile`, {
                params: {}}, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (result.status === 200) {
                // Stop Loader
                commit('SET_LOADER', false);

                commit('SET_GESTIONES', result.data.managements)
                commit('SET_USERS_MANAGEMENTS_ROLES', result.data.usersManagementsRoles)
                commit('SET_USERS_MANAGEMENTS_ROLES_FILTERED', result.data.usersManagementsRoles)
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    loadProfileApi: async ({ state, dispatch, commit }, route) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let result = await axios.get(`/information/private/consultaConfiguraciones`, {params: { }}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            return result;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getUserByEmail: async ({ state, dispatch, commit }, email) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const user = await axios.get(`/information/private/getUserByEmail`, {
                params: { Email: email }}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (user.status === 200) {
                return user.data.user;
            } else {
                return null;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addUsersToManagement: async ({ state, dispatch, commit }, object) => {
        const stateDataManagements = state.gestiones;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const result = await axios.post(`/information/private/addUsersToManagement`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (result.status === 200) {
                commit('SET_USERS_MANAGEMENTS_ROLES', result.data.usersManagementsRoles)
                commit('SET_USERS_MANAGEMENTS_ROLES_FILTERED', result.data.usersManagementsRoles)

                // Update managements
                stateDataManagements.forEach((data, index) => {
                    if (data.Id_gestion === result.data.management[0].Id_gestion) {
                        Object.assign(stateDataManagements[index], result.data.management[0])
                    }
                })

                commit('SET_GESTIONES', stateDataManagements)

                dispatch('activeMessageCorrect', result.data.message);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editUsersManagementRoles: async ({ commit, dispatch, state }, object) => {
        const stateData = state.usersManagementsRoles;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const userRole = await axios.post(`/information/private/editUsersManagementRoles`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (userRole.status === 200) {
                stateData.forEach((data, index) => {
                    if (data.Id_usuarios_gestiones_roles === userRole.data.data[0].Id_usuarios_gestiones_roles) {
                        Object.assign(stateData[index], userRole.data.data[0])
                    }
                })

                commit('SET_USERS_MANAGEMENTS_ROLES', stateData);
                commit('SET_USERS_MANAGEMENTS_ROLES_FILTERED', stateData);

                dispatch('activeMessageCorrect', userRole.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteUsersManagementRoles: async ({ commit, dispatch, state }, object) => {
        const stateData = state.usersManagementsRoles;
        const stateDataManagements = state.gestiones;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const userRole = await axios.post(`/information/private/deleteUsersManagementRoles`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (userRole.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_usuarios_gestiones_roles === object.Id_usuarios_gestiones_roles) {
                        stateData.splice(index, 1)
                    }
                })

                commit('SET_USERS_MANAGEMENTS_ROLES', stateData);
                commit('SET_USERS_MANAGEMENTS_ROLES_FILTERED', stateData);

                // Remove user from management
                stateDataManagements.forEach((data, index) => {
                    if (data.Id_gestion === userRole.data.newManagement[0].Id_gestion) {
                        Object.assign(stateDataManagements[index], userRole.data.newManagement[0])
                    }
                })

                commit('SET_GESTIONES', stateDataManagements)

                dispatch('activeMessageCorrect', userRole.data.message)
                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    }
}